<!-- eslint-disable max-len -->
<!-- eslint-disable no-irregular-whitespace -->
<template>
  <div class="page-block">
    <header-bar v-if="isLoggedIn">配信規定</header-bar>
    <div class="page-block__heading page-block__heading--withbar">
      <h3 class="page-block__title">配信規定</h3>
    </div>
    <div class="page-block__inner">
      <div class="news-detail-area">
        <div class="news-detail">
          <div class="news-detail__heading">
            <p class="news-detail__title">アカウントについて</p>
          </div>
          <div class="news-detail__body">
            <p class="news-detail__paragraph">
              ＜アカウントの登録＞<br>
              利用規約の同意と、18歳未満のユーザーは保護者の同意が必要になります。<br>2年間ログインされていないアカウントについては、削除させていただく場合がございます。
            </p>
            <p class="news-detail__paragraph">
              ＜アカウントの退会＞<br>
              下記にご同意の上、アカウント情報画面の最下部にある「退会」よりお手続きをお願いいたします。<br>
              ・サブスクプランの契約解除が必要となります<br>
              ・サブスクプランのご契約期間が1年間未満の場合は、解約料が発生いたします<br>
              ・登録済みの楽曲は全配信サイトで全て配信停止となります<br>
              ・全ての収益は失効いたします<br>
              ・退会後に発生する収益については、お支払いすることはできません<br>
              ・いかなる理由があっても退会の取り消しはできません<br>
            </p>
            <p class="news-detail__paragraph">
              <span class="c-color-caution">※退会前に収益残高が1,000円を超える場合は、必ず支払申請を行ってください。</span>
            </p>
          </div>
        </div>
        <div class="news-detail">
          <div class="news-detail__heading">
            <p class="news-detail__title">リリースについて</p>
          </div>
          <div class="news-detail__body">
            <p class="news-detail__paragraph">
              楽曲配信のタイミングは、各配信ストアにより異なります。<br>
              配信希望日は配信ストア側の審査状況により、ご指定いただいた日付から遅れる場合がございます。<br>
              また、配信申請後のリリース情報の修正（ジャケット画像や楽曲ファイル、配信ストア設定を含む）は受け付けておりません。<br>
              配信停止は原則として受付できません。<br>
              やむを得ない事情がある場合は、
              <router-link :to="{name: 'contact'}">
                お問い合わせフォーム
              </router-link>
              にてお問い合わせ内容「配信停止」を選択し、必要事項を明記の上でお問い合わせください。
            </p>
            <p class="news-detail__paragraph">
              【配信停止をする際の注意点】<br>
              ・特定ストアのみの配信停止はできかねます<br>
              ・ストア側での再生回数がリセットされます<br>
              ・配信停止されることにより、ストア側のご登録情報は一旦初期化されます<br>
              ・既に登録されているプレイリストからは外れてしまいます<br>
              ・配信停止したリリースと同じJANコードを再度ご登録いただくことはできかねます<br>
              ・YouTubeマネタイズサービスに登録している場合、その登録も削除されます<br>
              ・払いきりプランでリリースした楽曲は、配信を停止して同タイトルを再申請する場合でも課金が発生いたします<br>
              ・同一リリースを再申請される場合は、今回配信を停止するリリースがマイリリースページにて「配信停止」になった後に申請が可能となります<br>
              ・配信停止の処理には数営業日のお時間を要します<br>
              ・配信停止日はご指定いただけません<br>
            </p>
            <p class="news-detail__paragraph">
              <span class="c-color-caution">
                ※修正の処理は数営業日かかります。<br>
                ・配信停止の処理には数営業日のお時間を要します。<br>
                ・また、配信停止日はご指定いただけません。<br>
              </span>
            </p>
          </div>
        </div>
        <div class="news-detail">
          <div class="news-detail__heading">
            <p class="news-detail__title">コンテンツについて</p>
          </div>
          <div class="news-detail__body">
            <p class="news-detail__paragraph">
              【アルバム/シングルについて】<br>
              シングルは1曲、アルバムは最大50曲までご登録いただけます。<br>
              ただし、サブスクプランをご利用の場合は月15曲までの配信申請上限がございます。<br>
              1回払いきりプランは上限なしでご登録可能です。
            </p>
            <p class="news-detail__paragraph">
              【サブスクプランの配信上限について】<br>
              サブスクプランでは、1アカウントで1か月に最大15曲まで配信申請が可能です。<br>
              申請数のカウントは、申請時点で行います。<br>
              ただし、以下の場合はカウント対象外となります。<br>
              ・審査で差し戻しとなった場合<br>
              ・審査で却下となった場合<br>
              月のカウント期間は、毎月1日の0:00〜末日の23:59までの申請分が対象となります。<br>
              差し戻し・却下が月をまたいだ場合は、カウントはリセットされます。<br>
              （例）11月30日に申請し、12月1日に差し戻しとなった場合 → 11月分にはカウントされませんが、再申請時は12月分としてカウントされます。<br>
              1か月内で上限まで配信申請を行わなかった場合、翌月への持ち越しはできません。
            </p>
            <p class="news-detail__paragraph">
              【楽曲ファイル形式】<br>
              アップロードする楽曲ファイルは、以下のフォーマットでの登録が必要です。
            </p>
            <p>・サンプルサイズ：16ビットまたは24ビット</p>
            <div class="news-detail__sample-rate">
              <p class="news-detail__sample-rate-title">
                ・サンプルレート：
              </p>
              <p>
                16ビットの場合 44.1kHz<br>
                24ビットの場合 最低44.1kHz以上(44.1kHz、48kHz、88.2kHz、96kHz、176.4kHz、192kHz)
              </p>
            </div>
            <p>・ビットレート：1411bps</p>
            <p>・チャンネル：ステレオ</p>
            <p>・ファイル形式：WAV</p>
            <p>・楽曲の長さ：10分以内</p><br>
            <p class="news-detail__paragraph">
              ハイレゾ音源の登録にも対応しております。<br>
              リリース登録時にハイレゾ音源をアップロードすると、ハイレゾ配信ストア以外は自動的に非ハイレゾ状態に変換されて配信されます。<br>
              別途、通常音源をアップロードする必要はありませんのでご安心ください。<br>
              ただし、アルバム内でサンプルサイズが異なるファイルを登録することはできませんので、 16ビットまたは24ビット、いずれかのサンプルサ
              イズに統一いただくよう、お願いいたします。<br>
              なお、過去にリリースしている楽曲ファイルを、ハイレゾ音源用の楽曲ファイルへ変更することはできませんのでご了承ください。<br><br>
              また、各配信ストアの配信条件に合わせて、形式を変更させて頂く場合があります
            </p>
            <p class="news-detail__paragraph">
              【ジャケット画像形式】<br>
              1.ジャケット画像は以下の形式で作成してください。<br>
              ・JPG または PNG イメージファイル<br>
              ・3000 x 3000 ピクセル以上の正方形 （6000×6000まで）<br>
              ・RGB カラーモード (白黒含む) 注：CMYK は使用できません。<br>・20M以内
            </p>
            <p class="news-detail__paragraph">
              2.以下のような画像を使用することはできません。<br>
              ・汎用的なアートテンプレート（単一色のみなど）<br>
              ・他の楽曲のジャケット画像として使用しているもの<br>
              ・著作権を侵害するような画像<br>
              ・各配信ストア名称や企業名、SNS名などのロゴ等<br>
              ・ブランド名や広告の記載<br>
              ・購入リンク及びURL、QRコードの記載（「iTunes Store」、「○○にて先行配信中」）<br>
              ・配信ストア外サイトへ誘導するURL、SNSアカウントID<br>
              ・品質上の問題（画質が粗く文字や被写体の判別が困難、ピントがあっていない、空白が多い、途中でカットされている）<br>
              ・値引きに関連している単語や表現の記載（「DVD 付き」、「歌詞付き」、「抽選」、「懸賞」、「セール価格」、「特価」、「奉仕価格」、「キャンペーン」）<br>
              ・誤解を招く情報の記載があるもの（楽曲に無関係なアーティスト・ボーカル・演奏者などの記載）<br>
              ・リリースと無関係な情報の記載があるもの、または登録されたリリースタイトル・アーティスト名と表記に差異があるもの<br>
              ・物理的商品に該当する単語や表現の記載（「CD」「Disc」「DVD」）<br>
              ・デジタル商品に対応する単語や表現の記載（「Digital Exclusive」「Digital Version」）<br>
              ・ポルノ写真及び、卑猥な画像<br>・ドイツ刑法典で規制されている全ての、ナチスの紋章（ハーケンクロイツ・卐・逆駒十字）や、ナチスに関連する単語や表現
            </p>
            <p class="news-detail__paragraph">
              【ジャンルについて】<br>
              下記ジャンル一覧から最大２つまで選択できます。配信ストア側ではジャンル1から優先して登録されます。<br>
              J-POP / ロック / オルタナティブ / ブルース / アニメ / ダンス / Electronic / エレクトロニック / 演歌/日本伝統
              / フォーク / ハウス / カラオケ / 歌謡曲 / K-Pop / レゲエ / R&B / Soul / テクノ / ジャズ / ワールド / ヒップホップ / ラップ
              / Vocal / サウンドトラック / Easy Listening / キッズ / ボサノバ / Spoken Word
            </p>
            <p class="news-detail__paragraph">
              <span class="c-color-caution">
                ※注意※<br>
                ・『カラオケ』が選択されているリリースは、iTunes, Apple Music 内の検索結果には反映されません<br>
                ・『カラオケ 』『サウンドトラック 』『Spoken Word 』を選択した場合「Facebook/Instagram ミュージックスタンプ」へは配信できません
              </span>
            </p>
          </div>
        </div>
        <div class="news-detail">
          <div class="news-detail__heading">
            <p class="news-detail__title">サービス及び利用料について</p>
          </div>
          <div class="news-detail__body">
            <p class="news-detail__paragraph">
              【料金プラン】<br>
              1) サブスクプラン（月15曲まで）<br>
              月額110円(税込)<br><br>
              2) 1回払いきりプラン<br>
              シングル 2,860円(税込)<br>
              アルバム 5,500円(税込)
            </p>
            <p class="news-detail__paragraph">
              <span class="c-color-caution">
                ※価格は変更されることがありますのでご了承ください。
              </span>
            </p>

            <p class="news-detail__paragraph">
              【サブスクプランの解約について】<br>
              アカウント情報画面から、ご契約プランの「解約する」よりお手続きをお願いします。<br>
              サブスクプランを解約する場合は、下記にご同意頂く必要がございます。
            </p>
            <p class="news-detail__paragraph">
              ・サブスクプランのご契約期間が1年間未満の場合、解約料として1,320円(税込)を解約手続き時にお支払いいただきます。<br>
              ・サブスクプランのご契約期間中に登録済みの楽曲は、全配信ストアで全て配信停止となります。<br>
              ・1回払いきりプランで再登録する場合は、再度楽曲登録が必要となります。<br>
            </p>
            <p class="news-detail__paragraph">
              【サービス価格以外の必要料金】<br>
              ・金融機関への振込手数料：330円（税込）<br>
              ・サービスにアクセスする際に発生する通信料、プロバイダ料金、その他インターネットの利用のために必要となる費用<br>
              ・キャリア決済手数料
            </p>
            <p class="news-detail__paragraph">
              【お支払い方法】<br>
              ・クレジットカード（VISA・Mastercard・JCB・American Express・Diners Club）<br>
              ・キャリア決済（auかんたん決済・d払い・ソフトバンクまとめて支払い）
            </p>
            <p class="news-detail__paragraph">
              【代金支払時期】<br>
              1) サブスクプラン<br>
              クレジットカード、キャリア決済：初回の当月分は楽曲登録時、2ヶ月目以降は毎月1日に自動課金
            </p>
            <p class="news-detail__paragraph">
              ２) 1回払いきりプラン<br>
              クレジットカード、キャリア決済：楽曲登録時に課金
            </p>
            <p class="news-detail__paragraph">
              <span class="c-color-caution">
                ※お客様の口座からの引き落とし等がされるのは、契約した各クレジットカード会社または各キャリアの指定する引き落とし日となります。
              </span>
            </p>
          </div>
        </div>
        <div class="news-detail">
          <div class="news-detail__heading">
            <p class="news-detail__title">収益について</p>
          </div>
          <div class="news-detail__body">
            <p class="news-detail__paragraph">
              収益は確定レポートが反映してから、ご自身で「支払い申請」を行う必要があります。振込は「支払い申請」を行った月の翌月末日に行います。
            </p>
            <p class="news-detail__paragraph">
              <span class="c-color-caution">
                ※翌月末日が銀行休業日の場合は、翌営業日となります。<br>
                ※1,000円以上から引出しが可能となります。但し、振込手数料は一律330円差し引かせていただきます。
              </span>
            </p>
            <p class="news-detail__paragraph">
              【確定レポート報告タイミング】<br>
              1ヶ月単位で毎月末締めとし、翌々月末にご報告します。<br>
              例：1月分→3月末にご報告
            </p>
            <p class="news-detail__paragraph">
              <span class="c-color-caution">
                ※当サービスでは確定レポートの反映のタイミングを確約しておりませんので、あらかじめご了承ください。
              </span>
            </p>
            <p class="news-detail__paragraph">
              【還元率】<br>
              ＜音楽配信＞<br>
              契約プランに関係なく、90％還元いたします。<br>
              <br>
              ＜YouTubeマネタイズサービス＞<br>
              80％還元となります。
            </p>
            <p class="news-detail__paragraph">
              <span class="c-color-caution">
                ※VOCALOID™︎その他音声合成ソフトを利用した楽曲は、上記に合わせてライセンス利用料を収益金額から15％控除させていただきます。<br>
                ただし、YAMAHA社が提供するエンジンに対しては利用料は控除いたしません。
              </span>
            </p>
          </div>
        </div>
        <div class="news-detail">
          <div class="news-detail__heading">
            <p class="news-detail__title">生成AIについて</p>
          </div>
          <div class="news-detail__body">
            <p class="news-detail__paragraph">
              当サービスでは、生成AIの利用に関し、アーティストの創作活動を補助する適正な利用は認める一方で、権利を侵害する行為や不正な方法による楽曲申請は禁止いたします。<br>
              AIを使用した楽曲の配信は、以下すべての条件を満たす必要があります。
            </p>
            <p class="news-detail__paragraph">
              ・AIのみで楽曲生成されていないこと<br>
              　AIによる自動生成ではなく、人間による作曲・編集など創作的な関与があること。<br>
              　※人間がクエリ入力のみ行った場合も「AIのみの生成」とみなします。<br>
            </p>
            <p class="news-detail__paragraph">
              ・必要な許諾をすべて取得していること<br>
              　AIによって生成されたコンテンツやその配信に関連して、使用された学習データ（楽曲・歌詞・原盤など）が第三者の権利を侵害していないこと。
            </p>
            <p class="news-detail__paragraph">
              上記の条件をすべて満たしていても、当社の利用規約や配信ストアの規定に基づき、生成AIに関する上記条件に違反していることを疑う合理的な理由がある場合には、当社の判断でリリース審査を却下、または配信停止する場合があります。<br>
              また、不適切なツールの使用と判断されないよう、十分にご注意ください。
            </p>
            <p class="news-detail__paragraph">
              ＜適正な利用と禁止行為について＞<br>
              ▼適正な利用の例<br>
              ・アーティスト自身のアイデアや制作を補助する目的で生成AIを活用すること<br>
              ・生成AIを参考にしながら、独自の創作を加えた楽曲を制作すること
            </p>
            <p class="news-detail__paragraph">
              ▼禁止行為の例<br>
              ・第三者の著作物を無断で使用・模倣した楽曲を生成し、申請する行為<br>
              ・ボットなどを用いて、生成AIで大量の楽曲を短時間に作成・申請する行為
            </p>
            <p class="news-detail__paragraph">
              上記のような行為が確認された場合、利用規約に基づきサービスの利用停止や、損害賠償を請求する可能性があります。また、状況によっては著作権者からの申し立てや賠償請求の対象となる可能性もございますので、十分にご注意ください。
            </p>
            <p class="news-detail__paragraph">
              ＜著作権登録・YouTubeマネタイズサービスの登録について＞<br>
              現在、narasu著作権管理サービスでは、第三者の権利を侵害する可能性を考慮し、アーティストの創作的寄与の大小を問わず、生成AIソフトを使用して制作された楽曲の著作権登録はお受けしておりません。<br>
              また、YouTubeマネタイズサービスのご登録もいただけませんので、ご留意ください。
            </p>
          </div>
        </div>
        <p class="news-detail__paragraph">
          本配信規定は2020年12月1日より実施いたします。<br>
          2025年5月1日改定<br>
          2025年12月8日改定
        </p>
        <div class="c-btn-wrap">
          <router-link
            :to="{ name: 'index' }"
            class="c-btn c-btn--back"
            href="#">
            戻る
            <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import HeaderBar from '../HeaderBar'

export default {
  name: 'Rules20251208',
  components: { HeaderBar },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
  },
  mounted() {
    if (!this.isBtoC) this.$router.push({ name: 'index' })
  },
}
</script>
